module.exports = __webpack_public_path__ + "img/Groupe 84.e7a80975.svg";